import { getFlattenedCountryList } from '@/constants/pickerRegions/regions'

export const getFlattenedLocales = () => {
  const flattenedCountryList = getFlattenedCountryList()

  const allCountries = Object.keys(
    flattenedCountryList,
  ) as (keyof typeof flattenedCountryList)[]

  const locales = allCountries.flatMap((country) =>
    flattenedCountryList[country].map(
      (language) => `${language as string}-${country}` as const,
    ),
  )

  return locales
}

export type SupportedLocale = ReturnType<typeof getFlattenedLocales>[number]
